<template>
  <v-container id="regular-forms" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card
          color="grey darken-3"
          icon="mdi-account"
          :title="
            $route.params.id
              ? $t('Edit Coursecategory')
              : $t('New Coursecategory')
          "
          class="px-5 py-3"
        >
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <v-form
            v-else
            ref="form"
            autocomplete="new-password"
            lazy-validation
            @submit.prevent="saveItem"
          >
            <v-row>
              <v-col>
                <v-text-field
                  v-model="formValues.name"
                  :label="$t('name')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="name"
                  :error-messages="errors.collect('name')"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="formValues.name_it"
                  :label="$t('name_it')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="name_it"
                  :error-messages="errors.collect('name_it')"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-textarea
                  v-model="formValues.description"
                  :label="$t('description')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="description"
                  :error-messages="errors.collect('description')"
                ></v-textarea>
              </v-col>
              <v-col>
                <v-textarea
                  v-model="formValues.description_it"
                  :label="$t('description_it')"
                  autocomplete="new-password"
                  v-validate="'required'"
                  required
                  data-vv-name="description_it"
                  :error-messages="errors.collect('description_it')"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select
                  v-model="formValues.course_category_id"
                  :items="selectableCategories"
                  :label="$t('Übergeordnete Kategorie')"
                  item-text="name"
                  item-value="id"
                  :error-messages="errors.collect('course_category_id')"
                ></v-select>
              </v-col>
              <v-col></v-col>
            </v-row>
            <v-card-actions class="pl-0">
              <v-btn
                class="mr-4"
                @click="$router.push({ name: 'courseCategory.index' })"
              >
                {{ $t("back") }}
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" class="mr-4" @click="saveItem">
                {{ $t("save") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { saveItem, fetchItem, fetchItems } from "../shared/services";
export default {
  name: "app-courseCategory-item",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      formValues: {
        name: ""
      },
      permissions: [],
      loading: true,
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        { text: "Email", value: "email" },
        { text: "", value: "action", sortable: false }
      ],
      categories: []
    };
  },
  mounted() {
    this.loading = true;
    this.getData().then(() => {
      if (this.$route.params.id) {
        fetchItem(this.$route.params.id).then(res => {
          this.formValues = res.data;
          this.loading = false;
        });
      } else {
        this.loading = false;
      }
    });
  },
  computed: {
    computedFormValues() {
      return {
        ...this.formValues
      };
    },
    selectableCategories() {
      return this.categories.filter(item => {
        return item.id != this.formValues.id && item.course_category_id == null;
      });
    }
  },
  methods: {
    getData() {
      return Promise.all([this.getCategories()]);
    },
    async saveItem() {
      this.$validator.reset();
      this.$validator.validateAll();
      let resp = await saveItem(
        this.$route.params.id,
        this.computedFormValues,
        this.$validator
      );
      if (resp.success) {
        this.$root.$notification(resp.message, { type: "success" });
        this.$router.push({ name: "courseCategory.index" });
      }
    },
    async getCategories() {
      this.categories = (await fetchItems(this.options)).data;
    }
  }
};
</script>

<style lang="scss" scoped></style>
